export type RemoveDuplicatesProps<TItem> = {
  items: TItem[];
  key?: keyof(TItem) | ((item: TItem) => unknown);
};

/** Remove duplicate items from an array of items. */
export function removeDuplicates<TITem>({
  items,
  key
}: RemoveDuplicatesProps<TITem>) {
  const existing = new Set<unknown>();
  const getKey = (typeof key === 'function') ? key : (
    (item: TITem): unknown => {
      return (key) ? item[key] : item;
    }
  );

  return items.filter((item) => {
    const itemKey = getKey(item);
    if (!existing.has(itemKey)) {
      existing.add(itemKey);
      return true;
    }

    return false;
  });
}
